"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _styles = require("@material-ui/core/styles");

var _createTheme = _interopRequireDefault(require("./createTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThemeProvider = function ThemeProvider(_ref) {
  var theme = _ref.theme,
      children = _ref.children;
  var hwTheme = (0, _createTheme.default)(theme);
  var muiTheme = (0, _styles.createMuiTheme)(theme);
  return _react.default.createElement(_styledComponents.ThemeProvider, {
    theme: hwTheme
  }, _react.default.createElement(_styles.MuiThemeProvider, {
    theme: muiTheme
  }, children));
};

ThemeProvider.propTypes = {
  theme: _propTypes.default.object
};
var _default = ThemeProvider;
exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/core/Theme/ThemeProvider.js